/**
 * Upload Schema — V2 Work Plans
 *
 * Maps to SchemaV2WorkPlanPost in bldt-ui-fn/v2WorkPlans/schemas.ts
 * POST required: amount, currency, dateEnd, dateStart, name, projectId
 */

import { UploadSchema } from '../types';

export const v2WorkPlanSchema: UploadSchema = {
	entityType: 'v2WorkPlan',
	label: 'Work Plans',
	apiEndpoint: '/v2/work-plans',
	apiMethod: 'POST',
	customFieldEntityType: 'work_plan',
	fields: [
		{
			name: 'name',
			label: 'Work Plan Name',
			dataType: 'string',
			required: true,
			constraints: { minLength: 1, maxLength: 255 },
			headerAliases: ['Work Plan', 'WP Name', 'Title', 'Plan Name'],
		},
		{
			name: 'amount',
			label: 'Amount',
			dataType: 'number',
			required: true,
			constraints: { min: 0 },
			headerAliases: ['Budget', 'Total Amount', 'Planned Budget', 'Amount (USD)'],
		},
		{
			name: 'currency',
			label: 'Currency',
			dataType: 'string',
			required: true,
			constraints: { minLength: 3, maxLength: 3 },
			defaultValue: 'USD',
			headerAliases: ['Currency Code', 'Ccy'],
		},
		{
			name: 'dateStart',
			label: 'Start Date',
			dataType: 'date',
			required: true,
			headerAliases: ['Start', 'From Date', 'Begin Date', 'Period Start'],
		},
		{
			name: 'dateEnd',
			label: 'End Date',
			dataType: 'date',
			required: true,
			headerAliases: ['End', 'To Date', 'Completion Date', 'Period End'],
		},
		{
			name: 'entityId',
			label: 'Implementing Entity',
			dataType: 'relation',
			required: false,
			relation: {
				entityType: 'entity',
				matchField: 'name',
				idField: 'id',
				contextKey: 'entities',
				alternateMatchFields: ['idExternal'],
			},
			headerAliases: ['Entity', 'Implementing Agency', 'Agency'],
		},
		{
			name: 'amountLocal',
			label: 'Amount (Local Currency)',
			dataType: 'number',
			required: false,
			constraints: { min: 0 },
			headerAliases: ['Local Amount', 'Local Currency Amount', 'Amount Local'],
		},
		{
			name: 'currencyLocal',
			label: 'Local Currency',
			dataType: 'string',
			required: false,
			constraints: { minLength: 3, maxLength: 3 },
			headerAliases: ['Local Currency Code', 'Local Ccy', 'Currency Local'],
		},
		{
			name: 'fiscalYear',
			label: 'Fiscal Year',
			dataType: 'string',
			required: false,
			constraints: { maxLength: 10 },
			headerAliases: ['FY', 'Financial Year', 'Fiscal Year'],
		},
		{
			name: 'description',
			label: 'Description',
			dataType: 'string',
			required: false,
			headerAliases: ['Details', 'Notes', 'Work Plan Description'],
		},
		{
			name: 'parentWorkPlanId',
			label: 'Parent Work Plan',
			dataType: 'relation',
			required: false,
			relation: {
				entityType: 'workPlan',
				matchField: 'name',
				idField: 'id',
				contextKey: 'workPlans',
			},
			headerAliases: ['Parent', 'Parent WP', 'Parent Plan'],
		},
	],
};
